import {jwtDecode} from "jwt-decode";

export const isTokenExpiring = (token) => {
    if (!token) return true;
    
    try {
        const decoded = jwtDecode(token);
        const expirationTime = decoded.exp * 1000;
        const currentTime = Date.now();
        const bufferTime = 5 * 60 * 1000; // 5 minutes buffer

        const timeUntilExpiry = expirationTime - currentTime;
        const isExpiring = timeUntilExpiry < bufferTime;

        console.log(`Token expires in ${Math.round(timeUntilExpiry / 1000 / 60)} minutes, buffer: ${Math.round(bufferTime / 1000 / 60)} minutes`);

        return isExpiring;
    } catch (error) {
        console.error("Failed to decode token for expiry check:", error);
        return true;
    }
}

export const getLoggedInUserDetails = (token) => {
    if (!token) return null;
    
    try {
        const decoded = jwtDecode(token);
        return decoded.userDetail || decoded;
    } catch (error) {
        console.error("Failed to decode token for user details:", error);
        return null;
    }
}

export const isTokenValid = (token) => {
    if (!token) {
        console.log("No token provided for validation");
        return false;
    }

    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        const isValid = decoded.exp > currentTime;

        console.log(`Token validation: exp=${decoded.exp}, current=${currentTime}, valid=${isValid}`);

        return isValid;
    } catch (error) {
        console.error("Failed to validate token:", error);
        return false;
    }
}

export const getTokenExpiryTime = (token) => {
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return new Date(decoded.exp * 1000);
    } catch (error) {
        console.error("Failed to get token expiry time:", error);
        return null;
    }
}

export const debugTokenStatus = () => {
    const accessTokenName = process.env.REACT_APP_AUTH_TOKEN_KEY || 'token';
    const refreshTokenName = process.env.REACT_APP_REFRESH_TOKEN_KEY || 'refreshToken';

    const accessToken = localStorage.getItem(accessTokenName);
    const refreshToken = localStorage.getItem(refreshTokenName);

    console.log('=== Token Debug Information ===');
    console.log('Access Token exists:', !!accessToken);
    console.log('Refresh Token exists:', !!refreshToken);

    if (accessToken) {
        const isValid = isTokenValid(accessToken);
        const isExpiring = isTokenExpiring(accessToken);
        const expiryTime = getTokenExpiryTime(accessToken);

        console.log('Access Token valid:', isValid);
        console.log('Access Token expiring soon:', isExpiring);
        console.log('Access Token expiry time:', expiryTime);

        try {
            const decoded = jwtDecode(accessToken);
            console.log('Access Token payload:', decoded);
        } catch (error) {
            console.error('Failed to decode access token:', error);
        }
    }

    if (refreshToken) {
        try {
            const decoded = jwtDecode(refreshToken);
            console.log('Refresh Token payload:', decoded);
        } catch (error) {
            console.error('Failed to decode refresh token:', error);
        }
    }

    console.log('=== End Token Debug ===');
}
